import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Page from './Page';
import Logo from '../components/Logo';
import MessagePopup from '../components/MessagePopup';

const Home = () => {
  
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const [bgImageUrl, setBgImageUrl] = useState('/images/homepage-desktop.jpg');
  const [message, setMessage] = useState('Enter the correct password');
  const [messageActive, setMessageActive] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordInput, setShowPasswordInput] = useState(false);

  const navigateToIntro = () => {
    // if(showPasswordInput) {
    //   var password = jQuery('#frontend_login_input').val();
    //   jQuery.ajax({
    //     url: 'https://app.thegambit.gr/admin/login-authenticate-customer.php',
    //     method: 'POST',
    //     data: {
    //       password: password
    //     },
    //     success: function(response) {
    //       var status = JSON.parse(response).status;
    //       if(parseInt(status) === 1) {
    //         function setCookie(cname, cvalue, exdays) {
    //           const d = new Date();
    //           d.setTime(d.getTime() + (exdays*24*60*60*1000));
    //           let expires = "expires="+ d.toUTCString();
    //           document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    //         }
    //         setCookie('thegambit_customer_login', password, 31);
    //         navigate('/intro');
    //       } else {
    //         // alert('Enter the correct password');
    //         setMessage('Enter a correct password');
    //         setMessageActive(true);
    //       }
    //     },
    //     fail: function(xhr, textStatus, errorThrown) {
    //         // alert('Enter the correct password');
    //         setMessage('Enter a correct password');
    //         setMessageActive(true);
    //     }
    //   });
    // } else {
      navigate('/intro');
    // }
    
  };

  // const changeBgImage = () => {
  //   var windowWidth = window.innerWidth;
  //   if(windowWidth <= 768) {
  //     setBgImageUrl('/images/homepage-mobile.jpg');
  //   } else {
  //     setBgImageUrl('/images/homepage-desktop.jpg');
  //   }
  // }

  const getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    if(!loaded) {
      setLoaded(true);   
    //   // Show password input if user is not logged in or password expired
    //   var loginCookie = getCookie('thegambit_customer_login');
    //   if(loginCookie.length <= 0) {
    //     setShowPasswordInput(true);
    //   } else {
    //     jQuery.ajax({
    //       url: 'https://app.thegambit.gr/admin/login-authenticate-customer.php',
    //       method: 'POST',
    //       data: {
    //         password: loginCookie
    //       },
    //       success: function(response) {
    //         var status = JSON.parse(response).status;
    //         if(parseInt(status) !== 1) {
    //           setShowPasswordInput(true);
    //         }
    //       }
    //     });
    //   }

    //VAG
      setShowPasswordInput(true);

    }
    
  }, []);

  return (
  // VAG
    navigateToIntro()
    // <Page
    //   extraClasses={'home-page'}
    //   content={
    //     <div className="content" style={{backgroundImage: `url(${bgImageUrl})`}}>
    //         <div className={`inner-intro active`}>
    //             <div className='inner-intro-logo'>
    //                 <Logo />
    //                 {showPasswordInput && 
    //                   <>
    //                     <div className={`home-input-container ${showPassword ? 'viewing' : ''}`}>
    //                       <input type={`${showPassword ? 'text' : 'password'}`} id="frontend_login_input" />
    //                       <div className='password-button password-view' onClick={() => setShowPassword(true)}>
    //                         <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                           <path fillRule="evenodd" clipRule="evenodd" d="M20.7703 12C20.7703 11.6412 20.5762 11.4056 20.188 10.9343C18.768 9.21014 15.6357 6 12 6C8.36428 6 5.23207 9.21014 3.81198 10.9343C3.42382 11.4056 3.22974 11.6412 3.22974 12C3.22974 12.3588 3.42382 12.5944 3.81198 13.0657C5.23207 14.7899 8.36428 18 12 18C15.6357 18 18.768 14.7899 20.188 13.0657C20.5762 12.5944 20.7703 12.3588 20.7703 12ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3432 9 9.00002 10.3431 9.00002 12C9.00002 13.6569 10.3432 15 12 15Z" fill="white"/>
    //                         </svg>
    //                       </div>
    //                       <div className='password-button password-hide' onClick={() => setShowPassword(false)}>
    //                         <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                           <path fillRule="evenodd" clipRule="evenodd" d="M18.2371 15.1157C19.0484 14.3833 19.7137 13.6416 20.188 13.0657C20.5762 12.5944 20.7703 12.3588 20.7703 12C20.7703 11.6412 20.5762 11.4056 20.188 10.9343C18.768 9.21014 15.6357 6 12 6C11.1605 6 10.3479 6.17115 9.57695 6.45563L12.1238 9.00251C13.6822 9.06577 14.9342 10.3178 14.9975 11.8762L18.2371 15.1157ZM9.39308 10.5144C9.14295 10.9524 9.00001 11.4595 9.00001 12C9.00001 13.6569 10.3432 15 12 15C12.5405 15 13.0476 14.8571 13.4856 14.6069L15.7872 16.9085C14.636 17.5555 13.3529 18 12 18C8.36428 18 5.23207 14.7899 3.81198 13.0657C3.42382 12.5944 3.22974 12.3588 3.22974 12C3.22974 11.6412 3.42382 11.4056 3.81198 10.9343C4.48541 10.1167 5.54385 8.96489 6.85842 7.97974L9.39308 10.5144Z" fill="white"/>
    //                           <path d="M5 2L21 18" stroke="white" strokeWidth="2"/>
    //                         </svg>
    //                       </div>
    //                     </div>
    //                   </>
    //                 }
    //                 <div
    //                 className="align-to-right login"
    //                 onClick={() => navigateToIntro()}
    //                 >
    //                 LOG IN..
    //                 </div>
    //             </div>
    //             {/* <div className='inner-intro-signature'>
    //             BY <strong>PANAGIOTIS SOPIADIS</strong>
    //             </div> */}
    //         </div>
    //         <MessagePopup message={message} isActive={messageActive} onClosed={() => setMessageActive(false)} />
    //     </div>
    //   }
    //   outroInstant={true}
    // />
  );
};

export default Home;
